import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const NoImageFound = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="no image found icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M3 2C1.89543 2 1 2.89543 1 4V14C1 15.1046 1.89543 16 3 16L3 6C3 4.89543 3.89543 4 5 4H18C18 2.89543 17.1046 2 16 2H3Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5152 6L20.9998 2.88215C21.6172 2.32976 22.5655 2.38244 23.1179 2.99982C23.6703 3.6172 23.6176 4.56549 23.0002 5.11788L4.00019 22.1179C3.38281 22.6703 2.43453 22.6176 1.88214 22.0002C1.32975 21.3828 1.38243 20.4345 1.99981 19.8822L5 17.1978V8C5 6.89543 5.89543 6 7 6H17.5152ZM9.5 11C10.3284 11 11 10.3284 11 9.5C11 8.67157 10.3284 8 9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11Z"
    />
    <path
      className={pathClass}
      d="M9.48488 20H20C21.1046 20 22 19.1046 22 18V8.80226L16.7196 13.5268L20 18H11.7202L9.48488 20Z"
    />
  </svg>
)
